<script setup>
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { ref, onMounted, computed, watch, nextTick, onBeforeUnmount } from 'vue';
import {useRoute, useRouter} from 'vue-router';
const router = useRouter();
import { getTranslation } from "../src/js/helpers/translations";

import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css'; // Import CSS if needed
const mainPaginationArray = ref([]);
const showDesc = ref(true);
const filtersActive = ref(false);
const perPage = 12;
const currentPage = ref(1);
const swiperInstances = ref([]);
const params = ref({
    currentPage: '',
    initial: '',
    city: '',
    size: '',
    plotSize: '',
    yearBuiltStart: '',
    yearBuiltEnd: '',
    order: '',
    bathrooms: '',
    bedrooms: '',
    type: '',
    sTerm: '',
    priceRange: '',
    seaView: '',
    seaFront: '',
    waterFront: '',
    nearTheSea: '',
    beachFront: '',
    mountainView: '',
    riverView: '',
    lakeView: '',
    nearTown: '',
    village: '',
    heatedPool: '',
    outdoorPool: '',
    indoorPool: '',
    boatMooring: '',
    garage: '',
    hotTub: '',
    vineyard: '',
    gym: '',
    sauna: '',
    wineCellar: '',
    tennisCourt: '',
    gameRoom: '',
    garden: '',
    terrace: '',
    balcony: '',
    outdoorKitchen: '',
    elevator: '',
})
let properties = ref({});
let showBtn = ref(false);
let categories = ref({});
let regions = ref({});
let pageContent = ref({});
let termCity = ref('not-selected');
let order = ref('not-selected');
let min = ref('');
let max = ref('');
let searchTerm = ref('');
const minSize = ref(0);
const maxSize = ref(2000);
let minPlotSize = ref(0);
let maxPlotSize = ref(200000);
let termSubCity = ref('not-selected');
let termSubCityList = ref([]);
let propertyTypeList = ref([]);
let propertyType = ref('not-selected');
let bedrooms = ref('not-selected');
let bathrooms = ref('not-selected');

let seaView = ref(false);
let waterFront = ref(false);
let nearTheSea = ref(false);
let beachFront = ref(false);
let mountainView = ref(false);
let riverView = ref(false);
let lakeView = ref(false);
let nearTown = ref(false);
let village = ref(false);

let heatedPool = ref(false);
let outdoorPool = ref(false);
let indoorPool = ref(false);
let boatMooring = ref(false);
let garage = ref(false);
let hotTub = ref(false);
let vineyard = ref(false);
let gym = ref(false);
let sauna = ref(false);
let wineCellar = ref(false);
let tennisCourt = ref(false);
let gameRoom = ref(false);
let garden = ref(false);
let terrace = ref(false);
let balcony = ref(false);
let outdoorKitchen = ref(false);
let elevator = ref(false);

let yearBuiltStart = ref('');
let yearBuiltEnd = ref('');

let initial = ref(false);
let loading = ref(false);
const translations = getTranslation(getLangCode);

// PRICE RANGE
const minPrice = 50000;
const maxPrice = 10000000;
const priceRange = ref([minPrice, maxPrice]);
const sizeRange = ref([minSize.value, maxSize.value]);

const tempMinSize = ref(minSize.value);
const tempMaxSize = ref(maxSize.value);

const plotSizeData = [
    0, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
    1500, 2000, 2500, 3000, 3500, 4000, 5000, 10000, 20000, 30000, 40000, 50000, 75000, 100000, 150000, 200000
];

const plotSizeMarks = {
    0: '0',
    400: '400',
    800: '800',
    1000: '1k',
    5000: '5k',
    10000: '10k',
    200000: '200k'
};

const plotSizeRange = ref([minPlotSize.value, maxPlotSize.value]);

const tempMinPlotSize = ref(plotSizeRange.value[0]);
const tempMaxPlotSize = ref(plotSizeRange.value[1]);


let contents = new URL(MyScriptVars.rest_url + 'contents');
// Object.keys(params.value).forEach(key => url.searchParams.append(key, params.value[key]));

const maxPages = computed(() => {
    return Math.ceil(properties.value.count / perPage);
});

watch(termCity, (after) => {
    if (initial.value !== false ) {
        termSubCity.value = 'not-selected';
        termSubCityList.value = properties.value.city.filter((city) => {
            return parseInt(city.parent) === parseInt(after);
        });
    }
});

// Input changes → update slider
watch([tempMinSize, tempMaxSize], ([newMin, newMax]) => {
    sizeRange.value = [newMin, newMax];
});

// Slider changes → update input
watch(sizeRange, ([minVal, maxVal]) => {
    if (minVal > maxVal) {
        // Prevent weird slider behavior
        sizeRange.value = [maxVal, maxVal];
    }
    tempMinSize.value = minVal;
    tempMaxSize.value = maxVal;
});

watch([tempMinPlotSize, tempMaxPlotSize], ([newMin, newMax]) => {
    plotSizeRange.value = [newMin, newMax];
});

watch(plotSizeRange, ([minVal, maxVal]) => {
    if (minVal > maxVal) {
        plotSizeRange.value = [maxVal, maxVal];
    }
    tempMinPlotSize.value = minVal;
    tempMaxPlotSize.value = maxVal;
});


const userContent = ref({
    firstPart: '',
    secondPart: '',
});

async function fetchData() {
    try {
        loading.value = true;
        let url = new URL(MyScriptVars.rest_url + 'properties');
        params.value.initial = 'true';
        params.value.croatiaPropertyID = croatiaPageID;
        Object.keys(params.value).forEach(key => url.searchParams.append(key, params.value[key]));

        const propertiesResponse = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: new Headers({
                'X-WP-Nonce': MyScriptVars.nonce
            })
        });
        if (!propertiesResponse.ok) throw new Error('Network response was not ok for properties');
        properties.value = await propertiesResponse.json();
        setRegions();
        loading.value = false;

    } catch (error) {
        console.error('Fetch operation failed:', error);
    }
}
const showText = () => {
    showDesc.value = true;
    showBtn.value = false;
    userContent.value.firstPart = properties.value.content;
}
const setRegions = () => {

    regions.value = properties.value.city.filter( (city) => {
        return !city.parent
    });
    console.log('dela', regions.value);
    propertyTypeList.value = properties.value.type;
    console.log('del2a', propertyTypeList.value);
    console.log('del3333', properties.value.selectedTerm);
    if (properties.value.selectedTerm) {
        if (properties.value.selectedTerm.parent) {
            termCity.value =  properties.value.selectedTerm.parent;
            termSubCityList.value = properties.value.city.filter((city) => {
                return parseInt(city.parent) === parseInt(properties.value.selectedTerm.parent);
            });
            termSubCity.value =  properties.value.selectedTerm.term_id
        } else {
            termCity.value =  properties.value.selectedTerm.term_id
        }
    }
    if (properties.value.selectedType) {
        propertyType.value =  properties.value.selectedType.term_id
    }
    console.log('termCity', termCity.value);
    console.log('sub', termSubCity.value);
}
const wordCount = (str) => {
    if (str) {
        return str.split(" ").length;
    }
    return 0;
}
const cutSentence = (str,start, end) => {
    return str.split(" ").splice(start,end).join(" ") + '...';
}

const showMoreFilters = () => {
    document.body.classList.add('overflow');
    filtersActive.value = true;
}
const hideMoreFilters = () => {
    document.body.classList.remove('overflow');
    filtersActive.value = false;
}
const getPropertyPermalink = (property) => {
    if (!property) return '';
    if (getLangCode == 'de') return property.permalink_de;
    if (getLangCode == 'hr') return property.permalink_hr;
    if (getLangCode == 'cs') return property.permalink_cs;
    if (getLangCode == 'es') return property.permalink_es;
    if (getLangCode == 'fr') return property.permalink_fr;
    if (getLangCode == 'sl') return property.permalink_sl;
    if (getLangCode == 'hu') return property.permalink_hu;
    if (getLangCode == 'pl') return property.permalink_pl;
    if (getLangCode == 'fi') return property.permalink_fi;
    if (getLangCode == 'no') return property.permalink_no;
    if (getLangCode == 'sv') return property.permalink_sv;
    if (getLangCode == 'sk') return property.permalink_sk;
    if (getLangCode == 'it') return property.permalink_it;
    if (getLangCode == 'uk') return property.permalink_uk;
    if (getLangCode == 'nl') return property.permalink_nl;
    return property.permalink;
}

const getPropertyTitle = (property) => {
    if (!property) return '';
    if (getLangCode == 'de') return property.title_de;
    if (getLangCode == 'hr') return property.title_hr;
    if (getLangCode == 'cs') return property.title_cs;
    if (getLangCode == 'es') return property.title_es;
    if (getLangCode == 'fr') return property.title_fr;
    if (getLangCode == 'sl') return property.title_sl;
    if (getLangCode == 'hu') return property.title_hu;
    if (getLangCode == 'pl') return property.title_pl;
    if (getLangCode == 'fi') return property.title_fi;
    if (getLangCode == 'no') return property.title_no;
    if (getLangCode == 'sv') return property.title_sv;
    if (getLangCode == 'sk') return property.title_sk;
    if (getLangCode == 'it') return property.title_it;
    if (getLangCode == 'uk') return property.title_uk;
    if (getLangCode == 'nl') return property.title_nl;
    return property.title;
}

const getPropertyCategory = (termCategory) => {
    if (!termCategory) return '';
    if (getLangCode == 'de') return termCategory.name_de;
    if (getLangCode == 'hr') return termCategory.name_hr;
    if (getLangCode == 'cs') return termCategory.name_cs;
    if (getLangCode == 'es') return termCategory.name_es;
    if (getLangCode == 'fr') return termCategory.name_fr;
    if (getLangCode == 'sl') return termCategory.name_sl;
    if (getLangCode == 'hu') return termCategory.name_hu;
    if (getLangCode == 'pl') return termCategory.name_pl;
    if (getLangCode == 'fi') return termCategory.name_fi;
    if (getLangCode == 'no') return termCategory.name_no;
    if (getLangCode == 'sv') return termCategory.name_sv;
    if (getLangCode == 'sk') return termCategory.name_sk;
    if (getLangCode == 'it') return termCategory.name_it;
    if (getLangCode == 'uk') return termCategory.name_uk;
    if (getLangCode == 'nl') return termCategory.name_nl;
    return termCategory.name;
}
const getCategoryPermalink = (category) => {
    if (!category) return '';
    if (getLangCode == 'de') return category.permalink_de;
    if (getLangCode == 'hr') return category.permalink_hr;
    if (getLangCode == 'cs') return category.permalink_cs;
    if (getLangCode == 'es') return category.permalink_es;
    return category.permalink;
}
const getBasePrice = (price) => {
    let basePrice = price.replaceAll(',', '');
    basePrice = basePrice.replaceAll('.', '');
    return basePrice;
}

const updateVisibleImageSources = (swiper) => {
    const slides = swiper.slides;
    const activeIndex = swiper.activeIndex;
    const prevIndex = activeIndex - 1;
    const nextIndex = activeIndex + 1;
    [activeIndex, prevIndex, nextIndex].forEach(index => {
        if (index >= 0 && index < slides.length) {
            const img = slides[index].querySelector('img');
            if (img && !img.src && img.dataset.src) {
                img.src = img.dataset.src;
            }
        }
    });
};

const initSwipers = () => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];

    nextTick(() => {
        const swiperElements = document.querySelectorAll('.swiper-property');
        swiperElements.forEach(el => {
            const swiper = new Swiper(el, {
                modules: [Navigation],
                speed: 600,
                slidesPerView: 1,
                lazy: true,
                preloadImages: false,
                spaceBetween: 0,
                navigation: {
                    prevEl: el.querySelector('.swiper-button-prev'),
                    nextEl: el.querySelector('.swiper-button-next')
                },
                on: {
                    slideChange: function() {
                        updateVisibleImageSources(this);
                    }
                }
            });

            const prevButton = el.querySelector('.swiper-button-prev');
            const nextButton = el.querySelector('.swiper-button-next');

            if (prevButton) {
                prevButton.addEventListener('click', () => updateVisibleImageSources(swiper));
            }

            if (nextButton) {
                nextButton.addEventListener('click', () => updateVisibleImageSources(swiper));
            }

            swiperInstances.value.push(swiper);
        });
    });
}
const calculatePaginationArray = (currentPage, totalPages) => {
    const _currentPage = parseInt(currentPage);
    const _totalPages = parseInt(totalPages);
    const paginationArray = [];
    const contextCount = 2; // Number of pages before and after the current page

    // If there are less than 12 pages, return [1]
    if (_totalPages === 0) {
        mainPaginationArray.value = [1];
        return;
    }
    if (_totalPages < 2) {
        mainPaginationArray.value = [1];
        return;
    }

    // Always include the first page
    paginationArray.push(1);

    // Calculate the range of pages to display around the current page
    let startPage = Math.max(2, _currentPage - contextCount);
    let endPage = Math.min(_totalPages - 1, _currentPage + contextCount);

    // Determine if ellipses are needed before the context pages
    if (startPage > 2) {
        paginationArray.push('...');
    }

    // Add the context pages
    for (let i = startPage; i <= endPage; i++) {
        paginationArray.push(i);
    }

    // Determine if ellipses are needed after the context pages
    if (endPage < _totalPages - 1) {
        paginationArray.push('...');
    }

    // Always include the last page if more than one page
    if (_totalPages > 1) {
        paginationArray.push(_totalPages);
    }

    mainPaginationArray.value = paginationArray;
}

const setWidth = () => {
    const overflowText = document.querySelectorAll('.overflow-calc');

    overflowText.forEach(text => {
        const width = text.parentElement.offsetWidth;
        text.style.maxWidth = `${width - 1}px`;
        text.style.whiteSpace = 'nowrap';
    });
}

onMounted(async () => {
    await nextTick();
    setTimeout(async () => {
        if (Object.keys(router?.currentRoute?.value?.query).length > 0) {
            setParamsFromRouteQuery(router.currentRoute.value.query);
            await filterProperties();
        } else {
            await fetchData();
        }
        initial.value = true;
        calculatePaginationArray(currentPage.value, maxPages.value);
        initSwipers();
        hideDescription();
        setWidth();
        window.addEventListener('resize', setWidth);
        checkIfFavorite();
    }, 500)

});
const hideDescription = () => {
    let contentLength = wordCount(properties.value.content);
    if(contentLength > 70) {
        userContent.value.firstPart = cutSentence(properties.value.content, 0, 70);
        showBtn.value = true;
    } else {
        userContent.value.firstPart = properties.value.content;
    }
}
const changePage = async (page) => {
    loading.value = true;
    currentPage.value = page;
    const changeUrl = setUrl();
    if (initial.value) {
        addRouteQuery();
    }
    calculatePaginationArray(currentPage.value, maxPages.value)
    scrollToPropertiesScroll();
    try {
        const propertiesResponse = await fetch(changeUrl, {
            method: 'GET',
            credentials: 'same-origin',
            headers: new Headers({
                'X-WP-Nonce': MyScriptVars.nonce
            })
        });
        if (!propertiesResponse.ok) throw new Error('Network response was not ok for properties');
        properties.value = await propertiesResponse.json();
        initSwipers();
        setTimeout(() => {
            updatePrices();
        }, 300)
        loading.value = false;
    } catch (e) {
        console.log(e);
    }
}
const updatePrices = () => {
    const conversionRates = {
        euro: 1,       // Base currency
        dollar: 1.1,
        pound: 0.85
    };
    const prices = document.querySelectorAll('.change-price');
    const currency = document.querySelector('select[data-function="changeCurrency"]');
    prices.forEach(priceElement => {
        const basePrice = priceElement.getAttribute('data-base-price');
        // Check if base price is a number, ignore if it's a string like "Price upon request"
        if (!isNaN(basePrice)) {
            const convertedPrice = parseFloat(basePrice) * conversionRates[currency.value];
            priceElement.textContent = formatCurrency(convertedPrice, currency.value);
        } else {
            // If the base price is not a number, leave it as is
            priceElement.textContent = basePrice;
        }
    });
}
const formatCurrency = (value, currency) => {
    const currencySymbols = {
        euro: '€',
        dollar: '$',
        pound: '£'
    };
    const symbol = currencySymbols[currency.toLowerCase()] || '€';

    // Custom formatter for the number
    const formattedNumber = value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return `${symbol} ${formattedNumber}`;
}
const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
}
const scrollToPropertiesScroll = () => {
    const element = document.getElementById('properties-scroll');
    const elementRect = element.getBoundingClientRect();  // Get the position of the element relative to the viewport
    const absoluteElementTop = elementRect.top + window.pageYOffset;  // Calculate the absolute top position
    const offsetPosition = absoluteElementTop - 50;  // Subtract 50 pixels to apply the offset

    window.scrollTo({
        top: offsetPosition,  // Set top position considering the offset
        behavior: 'smooth'
    });
}
const filterClick = () => {
    currentPage.value = 1;
    hideMoreFilters();
    filterProperties();
}
const filterProperties = async () => {
    // currentPage.value = 1;
    loading.value = true;
    const changeUrl = setUrl();
    scrollToPropertiesScroll();
    if (initial.value) {
        addRouteQuery();
    }
    try {
        const propertiesResponse = await fetch(changeUrl, {
            method: 'GET',
            credentials: 'same-origin',
            headers: new Headers({
                'X-WP-Nonce': MyScriptVars.nonce
            })
        });
        if (!propertiesResponse.ok) throw new Error('Network response was not ok for properties');
        properties.value = await propertiesResponse.json();
        setRegions();
        if (termCity !== 'not-selected' && !initial.value) {
            termSubCityList.value = properties.value.city.filter((city) => {
                return parseInt(city.parent) === parseInt(termCity.value);
            });
        }
        if (properties.value.count === 0) {
            mainPaginationArray.value = [];
        } else {
            calculatePaginationArray(currentPage.value, maxPages.value)
        }
        hideMoreFilters();
        initSwipers();
        setTimeout(() => {
            updatePrices();
            updateLanguageUrls();
        }, 300)
        loading.value = false;

    } catch (e) {
        console.log(e);
    }
}
const addRouteQuery = () => {
    const queryParams = {};

    Object.entries(params.value).forEach(([key, value]) => {
        if (value !== '' && value !== undefined && value !== null) {
            queryParams[key] = value;
        }
    });

    router.push({
        query: queryParams
    });
}
const setParamsFromRouteQuery = (routerParam) => {
    if (routerParam.minPrice && routerParam.maxPrice) {
        priceRange.value = [routerParam.minPrice, routerParam.maxPrice]
    }
    params.value.croatiaPropertyID = croatiaPageID;
    currentPage.value = parseInt(routerParam.currentPage) ?? 1;
    termCity.value = routerParam.filterCityId || 'not-selected';
    termSubCity.value = routerParam.filterSubCityId || 'not-selected';
    if (routerParam.size) {
        const [min, max] = routerParam.size.split('-');
        const minNum = Number(min);
        const maxNum = Number(max);
        if (!isNaN(minNum) && !isNaN(maxNum)) {
            sizeRange.value = [minNum, maxNum];
        }
    }
    if (routerParam.plotSize) {
        const [minPlot, maxPlot] = routerParam.plotSize.split('-');
        const minPlotNum = Number(minPlot);
        const maxPlotNum = Number(maxPlot);
        if (!isNaN(minPlotNum) && !isNaN(maxPlotNum)) {
            plotSizeRange.value = [minPlotNum, maxPlotNum];
            tempMinPlotSize.value = minPlotNum;
            tempMaxPlotSize.value = maxPlotNum;
        }
    }
    order.value = routerParam.order || 'not-selected';
    propertyType.value = routerParam.type || 'not-selected';
    searchTerm.value = routerParam.sTerm || '';
    bedrooms.value = routerParam.bedrooms || 'not-selected';
    bathrooms.value = routerParam.bathrooms || 'not-selected';
    seaView.value = !!routerParam.seaView;
    waterFront.value = !!routerParam.waterFront;
    nearTheSea.value = !!routerParam.nearTheSea
    beachFront.value = !!routerParam.beachFront
    mountainView.value = !!routerParam.mountainView
    riverView.value = !!routerParam.riverView
    lakeView.value = !!routerParam.lakeView
    nearTown.value = !!routerParam.nearTown
    village.value = !!routerParam.village
    heatedPool.value = !!routerParam.heatedPool
    outdoorKitchen.value = !!routerParam.outdoorKitchen
    outdoorPool.value = !!routerParam.outdoorPool
    indoorPool.value = !!routerParam.indoorPool
    boatMooring.value = !!routerParam.boatMooring
    garage.value = !!routerParam.garage
    hotTub.value = !!routerParam.hotTub
    vineyard.value = !!routerParam.vineyard
    gym.value = !!routerParam.gym
    sauna.value = !!routerParam.sauna
    wineCellar.value = !!routerParam.wineCellar
    tennisCourt.value = !!routerParam.tennisCourt
    garden.value = !!routerParam.garden
    terrace.value = !!routerParam.terrace
    elevator.value = !!routerParam.elevator
    yearBuiltStart.value = routerParam.yearBuiltStart || '';
    yearBuiltEnd.value = routerParam.yearBuiltStart || '';
}
const clearFilters = () => {
    params.value = {
        currentPage: currentPage.value,  // Preserving the current page
        city: '',
        size: '',
        plotSize: '',
        yearBuiltStart: '',
        yearBuiltEnd: '',
        order: '',
        bathrooms: '',
        bedrooms: '',
        type: '',
        sTerm: '',
        priceRange: '',
        seaView: '',
        seaFront: '',
        waterFront: '',
        nearTheSea: '',
        beachFront: '',
        mountainView: '',
        riverView: '',
        lakeView: '',
        nearTown: '',
        village: '',
        heatedPool: '',
        outdoorPool: '',
        indoorPool: '',
        boatMooring: '',
        garage: '',
        hotTub: '',
        vineyard: '',
        gym: '',
        sauna: '',
        wineCellar: '',
        tennisCourt: '',
        gameRoom: '',
        garden: '',
        terrace: '',
        balcony: '',
        outdoorKitchen: '',
        elevator: '',
    };
    termCity.value = 'not-selected';
    order.value = 'not-selected';
    min.value = '';
    max.value = '';
    sizeRange.value = [minSize.value, maxSize.value];
    searchTerm.value = '';
    minSize.value = sizeRange.value[0];
    maxSize.value = sizeRange.value[1];
    plotSizeRange.value = [minPlotSize, maxPlotSize];
    tempMinPlotSize.value = 0;
    tempMaxPlotSize.value = 200000;
    minPlotSize.value = 0;
    maxPlotSize.value = 200000;
    termSubCity.value = 'not-selected';
    termSubCityList.value = [];
    propertyType.value = 'not-selected';
    bedrooms.value = 'not-selected';
    bathrooms.value = 'not-selected';

    seaView.value = false;
    waterFront.value = false;
    nearTheSea.value = false;
    beachFront.value = false;
    mountainView.value = false;
    riverView.value = false;
    lakeView.value = false;
    nearTown.value = false;
    village.value = false;

    heatedPool.value = false;
    outdoorPool.value = false;
    indoorPool.value = false;
    boatMooring.value = false;
    garage.value = false;
    hotTub.value = false;
    vineyard.value = false;
    gym.value = false;
    sauna.value = false;
    wineCellar.value = false;
    tennisCourt.value = false;
    gameRoom.value = false;
    garden.value = false;
    terrace.value = false;
    balcony.value = false;
    outdoorKitchen.value = false;
    elevator.value = false;

    yearBuiltStart.value = '';
    yearBuiltEnd.value = '';

    filterProperties();
}
const setUrl = () => {
    const minPrice =  priceRange.value[0]
    const maxPrice =  priceRange.value[1]
    let size = sizeRange.value ? `${sizeRange.value[0]}-${sizeRange.value[1]}` : '';
    let plotSize = `${plotSizeRange.value[0]}-${plotSizeRange.value[1]}`;
    const orderParam = order.value !== 'not-selected' ? order.value : '';
    const cityId = termSubCity.value !== 'not-selected' ? termSubCity.value : termCity.value;
    const filterCityId = termCity.value !== 'not-selected' ? termCity.value : '';
    const filterSubCityId = termSubCity.value !== 'not-selected' ? termSubCity.value : '';
    const city = cityId !== 'not-selected' ? cityId : '';
    const type = propertyType.value !== 'not-selected' ? propertyType.value : '';
    const bedroomsCount = bedrooms.value !== 'not-selected' ? bedrooms.value : '';
    const bathroomsCount = bathrooms.value !== 'not-selected' ? bathrooms.value : '';
    const seaViewParam = seaView.value === true ? 1 : '';
    const searchTermParam = searchTerm.value || '';
    const seaFrontParam = waterFront.value === true ? 1 : '';
    const waterFrontParam = waterFront.value === true ? 1 : '';
    const nearTheSeaParam = nearTheSea.value === true ? 1 : '';
    const beachFrontParam = beachFront.value === true ? 1 : '';
    const mountainViewParam = mountainView.value === true ? 1 : '';
    const riverViewParam = riverView.value === true ? 1 : '';
    const lakeViewParam = lakeView.value === true ? 1 : '';
    const nearTownParam = nearTown.value === true ? 1 : '';
    const villageParam = village.value === true ? 1 : '';
    const heatedPoolParam = heatedPool.value === true ? 1 : '';
    const outdoorPoolParam = outdoorPool.value === true ? 1 : '';
    const indoorPoolParam = indoorPool.value === true ? 1 : '';
    const boatMooringParam = boatMooring.value === true ? 1 : '';
    const garageParam = garage.value === true ? 1 : '';
    const hotTubParam = hotTub.value === true ? 1 : '';
    const vineyardParam = vineyard.value === true ? 1 : '';
    const gymParam = gym.value === true ? 1 : '';
    const saunaParam = sauna.value === true ? 1 : '';
    const wineCellarParam = wineCellar.value === true ? 1 : '';
    const tennisCourtParam = tennisCourt.value === true ? 1 : '';
    const gameRoomParam = gameRoom.value === true ? 1 : '';
    const gardenParam = garden.value === true ? 1 : '';
    const terraceParam = terrace.value === true ? 1 : '';
    const balconyParam = balcony.value === true ? 1 : '';
    const outdoorKitchenParam = outdoorKitchen.value === true ? 1 : '';
    const elevatorParam = elevator.value === true ? 1 : '';
    const yearBuiltStartParam = yearBuiltStart.value;
    const yearBuiltEndParam = yearBuiltEnd.value;
    params.value = {
        croatiaPropertyID: croatiaPageID,
        currentPage: currentPage.value,
        city,
        filterCityId,
        filterSubCityId,
        size,
        plotSize,
        yearBuiltStart: yearBuiltStartParam ,
        yearBuiltEnd: yearBuiltEndParam,
        order: orderParam,
        bathrooms: bathroomsCount,
        bedrooms: bedroomsCount,
        type,
        sTerm: searchTermParam,
        minPrice,
        maxPrice,
        seaView: seaViewParam,
        seaFront: seaFrontParam,
        waterFront: waterFrontParam,
        nearTheSea: nearTheSeaParam,
        beachFront: beachFrontParam,
        mountainView: mountainViewParam,
        riverView: riverViewParam,
        lakeView: lakeViewParam,
        nearTown: nearTownParam,
        village: villageParam,
        heatedPool: heatedPoolParam,
        outdoorPool: outdoorPoolParam,
        indoorPool: indoorPoolParam,
        boatMooring: boatMooringParam,
        garage: garageParam,
        hotTub: hotTubParam,
        vineyard: vineyardParam,
        gym: gymParam,
        sauna: saunaParam,
        wineCellar: wineCellarParam,
        tennisCourt: tennisCourtParam,
        gameRoom: gameRoomParam,
        garden: gardenParam,
        terrace: terraceParam,
        balcony: balconyParam,
        outdoorKitchen: outdoorKitchenParam,
        elevator: elevatorParam,
    };
    let changeUrl = new URL(MyScriptVars.rest_url + 'properties');
    console.log('new232');
    Object.entries(params.value).forEach(([key, value]) => {
        if (value !== '' && value !== undefined && value !== null) {
            changeUrl.searchParams.append(key, value);
        }
    });
    console.log('Final URL:', changeUrl.toString());

    return changeUrl;
}

const favorites = JSON.parse(localStorage.getItem('favorites')) ?? [];

const toggleFavorite = (property, id) => {
    const index = favorites.indexOf(id);

    if (index === -1) {
        favorites.push(id);
    } else {
        favorites.splice(index, 1);
    }

    localStorage.setItem('favorites', JSON.stringify(favorites));

    if (localStorage.getItem('favorites') !== null) {
        const storage = JSON.parse(localStorage.getItem('favorites'));
        if (storage.includes(id)) {
            property.favorite = true;
        } else {
            property.favorite = false;
        }
    }
};

const checkIfFavorite = () => {
    if (localStorage.getItem('favorites') !== null) {
        properties.value.posts.forEach((property) => {
            const id = property.id;
            const favorites = JSON.parse(localStorage.getItem('favorites'));
            return property.favorite = favorites.includes(id);
        })
    }
};
const priceTranslations = (price, perRequest) => {
    if (price.toLowerCase() === 'price upon request' || perRequest) {
        if (getLangCode === 'de') return 'Preis auf Anfrage';
        if (getLangCode === 'hr') return 'Cijena na upit';
        if (getLangCode === 'cs') return 'Ceník na vyžádání';
        if (getLangCode === 'es') return 'Precio a demanda';
        if (getLangCode === 'fr') return 'Prix sur demande';
        if (getLangCode === 'sl') return 'Cena na povpraševanje';
        if (getLangCode === 'pl') return 'Cena na zapytanie';
        if (getLangCode === 'hu') return 'Ár kérésre';
        if (getLangCode === 'sv') return 'Pris på förfrågan';
        if (getLangCode === 'nl') return 'Prijs op aanvraag';
        if (getLangCode === 'fi') return 'Hinta pyynnöstä';
        if (getLangCode === 'it') return 'Prezzo su richiesta';
        if (getLangCode === 'uk') return 'Ціна за запитом';
        if (getLangCode === 'sk') return 'Cena na vyžiadanie';
        if (getLangCode === 'no') return 'Pris på forespørsel';
        if (getLangCode === 'en') return 'Price Upon Request';
        return price;
    }
    return price;
}
const updateLanguageUrls = () => {
    // Get the current URL's query string
    const queryString = window.location.search;

    // Get all elements with the class 'lang-dropdown-item'
    const languageLinks = document.getElementsByClassName('lang-dropdown-item');

    // Function to remove duplicates from query string
    const removeDuplicateParams = (baseUrl, queryString) => {
        // Create a URL object to help parse and manipulate the URL
        const url = new URL(baseUrl, window.location.origin);
        const currentParams = new URLSearchParams(url.search);
        const newParams = new URLSearchParams(queryString);

        // Remove any duplicate params
        newParams.forEach((value, key) => {
            if (currentParams.has(key)) {
                currentParams.delete(key); // Avoid duplicating the param
            }
            currentParams.append(key, value); // Add the new param
        });

        return `${url.pathname}?${currentParams.toString()}`;
    };

    // Loop through each element and update its href attribute
    for (let i = 0; i < languageLinks.length; i++) {
        const link = languageLinks[i];
        const baseUrl = link.getAttribute('href');

        // If there's a query string, append it, ensuring no duplicates
        const updatedUrl = queryString ? removeDuplicateParams(baseUrl, queryString) : baseUrl;

        // Set the updated URL as the new href value
        link.setAttribute('href', updatedUrl);
    }
}
onBeforeUnmount(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    window.removeEventListener('resize', setWidth);
});


// Computed properties for formatted price inputs
const formattedMinPrice = computed({
    get() {
        return '€ ' + priceRange.value[0]
            .toLocaleString('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 })
            .replace('€', '')
            .trim();
    },
    set(value) {
        const numericValue = parseFloat(value.replace(/[^\d]/g, ''));
        if (!isNaN(numericValue)) {
            priceRange.value = [numericValue, priceRange.value[1]];
        }
    },
});

const formattedMaxPrice = computed({
    get() {
        return '€ ' + priceRange.value[1]
            .toLocaleString('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 })
            .replace('€', '')
            .trim();
    },
    set(value) {
        const numericValue = parseFloat(value.replace(/[^\d]/g, ''));
        if (!isNaN(numericValue)) {
            priceRange.value = [priceRange.value[0], numericValue];
        }
    },
});

const formatPrice = (value) => {
    return value.toLocaleString('de-DE');
};

const onMinPriceInput = (event) => {
    formattedMinPrice.value = event.target.value;
};

const onMaxPriceInput = (event) => {
    formattedMaxPrice.value = event.target.value;
};

const clearMinPrice = () => {
    priceRange.value = [minPrice, priceRange.value[1]];
};

const clearMinSize = () => {
    tempMinSize.value = minSize.value;
};

const clearMaxSize = () => {
    tempMaxSize.value = maxSize.value;
};

const clearMinPlotSize = () => {
    tempMinPlotSize.value = 0;
};

const clearMaxPlotSize = () => {
    tempMaxPlotSize.value = 200000;
};


const clearMaxPrice = () => {
    priceRange.value = [priceRange.value[0], maxPrice];
};

</script>

<template>
    <section class="property-list-section">
        <div
            class="property-filters m-60"
            :class="{'more-filters-mobile': moreFilters}"
            data-facet-category="real_estate"
            data-fixed=""
        >
            <div class="container-4">
                <div
                    class="property-filters-wrap grid"
                    :class="termCity !== 'not-selected' ? 'one-more' : ''"
                >
                    <div class="filter-item">
                        <label class="label-1">
                            {{ translations.search_word }}
                        </label>
                        <input class="input-1" type="text" v-model="searchTerm">
                    </div>

                    <div class="filter-item">
                        <label class="label-1">
                            {{ translations.region }}
                        </label>
                        <select name="zona" class="input-1" v-model="termCity">
                            <option value="not-selected">{{ translations.select }}</option>
                            <option v-for="region in regions" :value="region.term_id">{{ region.name }}</option>

                        </select>
                    </div>
                    <div class="filter-item" v-if="termSubCityList.length > 0">
                        <label class="label-1">
                            {{ translations.city }}
                        </label>
                        <select name="zona" class="input-1" v-model="termSubCity">
                            <option value="not-selected">{{ translations.select }}</option>
                            <option v-for="city in termSubCityList" :value="city.term_id">{{ city.name }}</option>
                        </select>
                    </div>
                    <div class="filter-item">
                        <label class="label-1">
                            {{ translations.sort_by }}
                        </label>
                        <select name="prezzo" class="input-1" v-model="order">
                            <option value="not-selected">{{ translations.select }}</option>
                            <option value="popular">{{ translations.popular }}</option>
                            <option value="price_low">{{ translations.low }}</option>
                            <option value="price_high">{{ translations.high }}</option>
                            <option value="newest">{{ translations.newest }}</option>
                            <option value="oldest">{{ translations.oldest }}</option>
                        </select>
                    </div>
                    <div class="filter-item" @click.prevent="filterClick()">
                        <button id="form_search_post" name="form_search_post" value="si" class="btn-1 full-width">
                            {{ translations.search }}
                        </button>
                    </div>
                    <div class="filter-item show-more-filters" @click.prevent="showMoreFilters()">
                        <button class="btn-1 full-width">
                            {{ translations.more_filters }}
                        </button>
                    </div>
                </div>
                <!-- todo add class active to filter-popup to toggle -->
                <div :class="filtersActive ? 'active' : ''" class="filter-popup fixed">
                    <div class="filter-popup-inner">
                        <div class="filter-popup-header relative">
                            <p class="filter-popup-title center">
                                {{ translations.filters }}
                            </p>
                            <a href="#" aria-label="Close" class="popup-close absolute" @click="hideMoreFilters()">
                                <svg viewBox="0 0 32 32">
                                    <path d="M26.6 6.80002L25.2 5.40002L16 14.6L6.80002 5.40002L5.40002 6.80002L14.6 16L5.40002 25.2L6.80002 26.6L16 17.4L25.2 26.6L26.6 25.2L17.4 16L26.6 6.80002Z"></path>
                                </svg>
                            </a>
                        </div>
                        <div class="filter-popup-items-wrap">
                            <div class="filter-popup-item">
                                <label class="label-2 m-10">
                                    {{ translations.type }}
                                </label>
                                <select name="property-type" class="input-1" v-model="propertyType">
                                    <option value="not-selected">{{ translations.select }}</option>
                                    <option v-for="type in propertyTypeList" :value="type.term_id">{{ getPropertyCategory(type) }}</option>
                                </select>
                            </div>
                            <div class="filter-popup-item">
                                <label class="label-2 m-10">
                                    {{ translations.bedrooms }}
                                </label>
                                <select name="prezzo" class="input-1" v-model="bedrooms">
                                    <option value="not-selected">{{ translations.select }}</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">{{ translations.more }}</option>
                                </select>
                            </div>
                            <!-- Price Range Slider Section -->
                            <div class="filter-popup-item">
                                <label class="label-2 m-10">
                                    {{ translations.price_range }}
                                </label>
                                <VueSlider
                                    v-model="priceRange"
                                    :min="minPrice"
                                    :max="maxPrice"
                                    :interval="10000"
                                    :tooltip="'never'"
                                    :use-keyboard="true"
                                    :formatter="formatPrice"
                                    :range="true"
                                    :process-style="{ backgroundColor: '#000' }"
                                    :dot-style="{ backgroundColor: '#000', border: '2px solid white' }"
                                />

                                <!-- Custom Input Fields with Clear Button Inside -->
                                <div class="input-container">
                                    <div class="slide-range-flex">
                                        <div data-v-83aca2="" class="input">
                                            <label>{{ translations.min_price }}</label>
                                            <div class="input-slide-container">
                                                <input
                                                    data-v-83aca2=""
                                                    class="input-1"
                                                    type="text"
                                                    v-model="formattedMinPrice"
                                                    @input="onMinPriceInput"
                                                    placeholder="€100,000"
                                                />
                                                <span v-if="formattedMinPrice" class="clear-icon" @click="clearMinPrice">×</span>
                                            </div>
                                        </div>

                                        <!-- Max Price Input -->
                                        <div data-v-83aca2="" class="input">
                                            <label>{{ translations.max_price }}</label>
                                            <div class="input-slide-container">
                                                <input
                                                    data-v-83aca2=""
                                                    class="input-1"
                                                    type="text"
                                                    v-model="formattedMaxPrice"
                                                    @input="onMaxPriceInput"
                                                    placeholder="€20,000,000"
                                                />
                                                <span v-if="formattedMaxPrice" class="clear-icon" @click="clearMaxPrice">×</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="filter-popup-item">
                                <label class="label-2 m-10">
                                    {{ translations.bathrooms }}
                                </label>
                                <select name="prezzo" class="input-1" v-model="bathrooms">
                                    <option value="not-selected">{{ translations.select }}</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">{{ translations.more }}</option>
                                </select>
                            </div>
                            <div class="filter-popup-item">
                                <label class="label-2 m-10">
                                    {{ translations.inside }}
                                </label>
                                <VueSlider
                                    v-model="sizeRange"
                                    :min="minSize"
                                    :max="maxSize"
                                    :interval="10"
                                    :tooltip="'never'"
                                    :use-keyboard="true"
                                    :range="true"
                                    :process-style="{ backgroundColor: '#000' }"
                                    :dot-style="{ backgroundColor: '#000', border: '2px solid white' }"
                                />

                                <!-- Custom Input Fields with Clear Button Inside -->
                                <div class="input-container">
                                    <div class="slide-range-flex">
                                        <div data-v-83aca2="" class="input">
                                            <label>{{ translations.min_size }}</label>
                                            <div class="input-slide-container">
                                                <input
                                                    data-v-83aca2=""
                                                    class="input-1"
                                                    type="text"
                                                    v-model="tempMinSize"
                                                    placeholder="100"
                                                />
                                                <span class="unit-suffix">m²</span>
                                                <span v-if="tempMinSize" class="clear-icon" @click="clearMinSize">×</span>
                                            </div>
                                        </div>

                                        <!-- Max Price Input -->
                                        <div data-v-83aca2="" class="input">
                                            <label>{{ translations.max_size }}</label>
                                            <div class="input-slide-container">
                                                <input
                                                    data-v-83aca2=""
                                                    class="input-1"
                                                    type="text"
                                                    v-model="tempMaxSize"
                                                    placeholder="2500"
                                                />
                                                <span class="unit-suffix">m²</span>
                                                <span v-if="tempMaxSize" class="clear-icon" @click="clearMaxSize">×</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="filter-popup-item">
                                <label class="label-2 m-10">
                                    {{ translations.plot }}
                                </label>
                                <VueSlider
                                    v-model="plotSizeRange"
                                    :min="0"
                                    :max="200000"
                                    :interval="100"
                                    :tooltip="'never'"
                                    :use-keyboard="true"
                                    :marks="plotSizeMarks"
                                    :data="plotSizeData"
                                    :range="true"
                                    :process-style="{ backgroundColor: '#000' }"
                                    :dot-style="{ backgroundColor: '#000', border: '2px solid white' }"
                                />
                                <div class="input-container">
                                    <div class="slide-range-flex">
                                        <div class="input">
                                            <label>{{ translations.min_plot }}</label>
                                            <div class="input-slide-container">
                                                <input
                                                    class="input-1"
                                                    type="text"
                                                    v-model="tempMinPlotSize"
                                                    placeholder="100"
                                                />
                                                <span class="unit-suffix">m²</span>
                                                <span v-if="tempMinPlotSize" class="clear-icon" @click="clearMinPlotSize">×</span>
                                            </div>
                                        </div>
                                        <div class="input">
                                            <label>{{ translations.max_plot }}</label>
                                            <div class="input-slide-container">
                                                <input
                                                    class="input-1"
                                                    type="text"
                                                    v-model="tempMaxPlotSize"
                                                    placeholder="200000"
                                                />
                                                <span class="unit-suffix">m²</span>
                                                <span v-if="tempMaxPlotSize" class="clear-icon" @click="clearMaxPlotSize">×</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="filter-popup-item group">
                                <label class="label-2 m-10 full-width">
                                    {{ translations.location }}
                                </label>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="seaView">
                                        <span>
                                       {{ translations.sea_view }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="waterFront">
                                        <span>
                                        {{ translations.waterfront }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="nearTheSea">
                                        <span>
                                        {{ translations.near_the_sea }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="beachFront">
                                        <span>
                                        {{ translations.beachfront }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="mountainView">
                                        <span>
                                        {{ translations.mountain_view }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="riverView">
                                        <span>
                                        {{ translations.river_view }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="lakeView">
                                        <span>
                                        {{ translations.lake_view }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="nearTown">
                                        <span>
                                        {{ translations.near_town }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="village">
                                        <span>
                                        {{ translations.village }}
                                    </span>
                                    </label>
                                </div>
                            </div>
                            <div class="filter-popup-item group group-2">
                                <label class="label-2 m-10 full-width">
                                    {{ translations.facilities }}
                                </label>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="heatedPool">
                                        <span>
                                       {{ translations.heated_pool }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="outdoorPool">
                                        <span>
                                        {{ translations.outdoor_pool }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="indoorPool">
                                        <span>
                                        {{ translations.indoor_pool }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="boatMooring">
                                        <span>
                                        {{ translations.boat_mooring }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="garage">
                                        <span>
                                        {{ translations.garage }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="hotTub">
                                        <span>
                                        {{ translations.hot_tub }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="vineyard">
                                        <span>
                                        {{ translations.vineyard }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="gym">
                                        <span>
                                        {{ translations.gym }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="sauna">
                                        <span>
                                        {{ translations.sauna }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="wineCellar">
                                        <span>
                                        {{ translations.wine_cellar }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="tennisCourt">
                                        <span>
                                        {{ translations.tennis_court }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="gameRoom">
                                        <span>
                                        {{ translations.game_room }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="garden">
                                        <span>
                                        {{ translations.garden }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="terrace">
                                        <span>
                                        {{ translations.terrace }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="balcony">
                                        <span>
                                        {{ translations.balcony }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="outdoorKitchen">
                                        <span>
                                        {{ translations.outdoor_kitchen }}
                                    </span>
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label class="checkbox-1">
                                        <input class="checkbox-filter" type="checkbox" v-model="elevator">
                                        <span>
                                        {{ translations.elevator }}
                                    </span>
                                    </label>
                                </div>
                            </div>
                            <div class="filter-popup-item group">
                                <label class="label-2 m-10 full-width">
                                    {{ translations.year_built }}
                                </label>
                                <div class="input">
                                    <input class="input-1" type="text" placeholder="1500" v-model="yearBuiltStart">
                                </div>
                                <div class="input">
                                    <input class="input-1" type="text" placeholder="2024" v-model="yearBuiltEnd">
                                </div>
                            </div>
                        </div>
                        <div class="filter-popup-bottom flex space-between">
                            <button @click.prevent="clearFilters" class="btn-1">
                                {{ translations.clear }}
                            </button>
                            <button @click.prevent="filterClick()" class="btn-1">
                                {{ translations.show }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-properties">
            <div v-if="properties.destinations && properties.destinations.length > 0" class="property-list-destinations m-20">
                <h2 class="m-20">
                    {{ translations.popular_destinations }}
                </h2>
                <div class="property-list-categories flex">
                    <a  v-for="destination in properties.destinations" :href="destination.permalink" class="category-link">
                        {{ destination.post_title  }}
                    </a>
                </div>
            </div>
            <div id="properties-scroll">
                <div v-if="loading" class="loader-wrap">
                    <div class="loader"></div>
                </div>
                <div v-else-if="properties.posts && properties.posts.length > 0" class="property-list-grid grid m-30" data-function="overflowCalculate">
                    <div v-for="property in properties.posts" class="property-item">
                        <div
                            class="favorite-btn"
                            :class="{'active': property.favorite }"
                            @click.prevent="toggleFavorite(property, property.id)"
                        >
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 471.701 471.701" xml:space="preserve">
                                <path d="M433.601,67.001c-24.7-24.7-57.4-38.2-92.3-38.2s-67.7,13.6-92.4,38.3l-12.9,12.9l-13.1-13.1 c-24.7-24.7-57.6-38.4-92.5-38.4c-34.8,0-67.6,13.6-92.2,38.2c-24.7,24.7-38.3,57.5-38.2,92.4c0,34.9,13.7,67.6,38.4,92.3 l187.8,187.8c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-3.9l188.2-187.5c24.7-24.7,38.3-57.5,38.3-92.4 C471.801,124.501,458.301,91.701,433.601,67.001z M414.401,232.701l-178.7,178l-178.3-178.3c-19.6-19.6-30.4-45.6-30.4-73.3 s10.7-53.7,30.3-73.2c19.5-19.5,45.5-30.3,73.1-30.3c27.7,0,53.8,10.8,73.4,30.4l22.6,22.6c5.3,5.3,13.8,5.3,19.1,0l22.4-22.4 c19.6-19.6,45.7-30.4,73.3-30.4c27.6,0,53.6,10.8,73.2,30.3c19.6,19.6,30.3,45.6,30.3,73.3 C444.801,187.101,434.001,213.101,414.401,232.701z"/>
                            </svg>
                        </div>
                        <a :href="property.youtube" v-if="property.youtube" target="_blank" class="video-link">
                            <img src="https://croatiarealestates.com/wp-content/uploads/2024/04/video-camera.png"/>
                        </a>
                        <a :href="getPropertyPermalink(property)" class="block">
                            <div class="property-item-slider m-15" id="property-item-slider" data-function="propertyItemSlider">
                                <div class="swiper swiper-property" ref="setSwiper">
                                    <div class="swiper-wrapper">
                                        <div v-for="(image, index) in property.gallery" class="swiper-slide">
                                            <div class="slide-inner relative overflow">
                                                <template v-if="index === 0">
                                                    <img :src="image.url" class="object-fit-cover" :alt="image.title">
                                                </template>
                                                <template v-else>
                                                    <img :data-src="image.url" class="object-fit-cover swiper-lazy swiper-hide-drag" :alt="image.title">
                                                    <div class="swiper-lazy-preloader"></div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-button-prev"></div>
                                    <div class="swiper-button-next"></div>
                                </div>
                            </div>
                            <p class="list-card-price text-8 color-1 medium change-price" :data-base-price="priceTranslations(getBasePrice(property.price), property.price_upon_request)">
                                € {{ priceTranslations(property.price, property.price_upon_request) }}
                            </p>
                            <p class="list-card-location text-1 color-1 overflow-calc">
                                {{ getPropertyTitle(property) }}
                            </p>
                            <p class="list-card-info text-1 color-3 overflow-calc">
                            <span v-if="property.bedrooms">
                                {{ property.bedrooms }} {{ translations.bedrooms }}
                            </span>
                            <span v-if="property.bathrooms">
                                {{ property.bathrooms }} {{ translations.bathrooms }}
                            </span>
                            <span v-if="property.size">
                                {{ property.size }} ㎡
                            </span>
                            </p>
                        </a>
                    </div>
                </div>
                <div v-else class="no-properties">
                    <h2>No properties found</h2>
                </div>
            </div>
            <div v-if="mainPaginationArray.length > 1" class="pagination ibf center">
                <a aria-label="1" href="#" @click.prevent="changePage(currentPage - 1, false)">
                    <span class="_prev" data-page="1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <polygon points="7.293 4.707 14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707"/>
                        </svg>
                    </span>
                </a>
                <a aria-label="3" href="#" @click.prevent="changePage(currentPage - 3, false)">
                    <span class="_prev" data-page="3">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g data-name="Double Arrow"><path d="M12 17a1 1 0 0 1-.707-1.707L14.586 12l-3.293-3.293a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4A1 1 0 0 1 12 17z" style="fill:#1c1b1e"/><path d="M8 17a1 1 0 0 1-.707-1.707L10.586 12 7.293 8.707a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4A1 1 0 0 1 8 17z" style="fill:#1c1b1e"/></g></svg>
                    </span>
                </a>
                <template v-for="pagination in mainPaginationArray">
                    <a v-if="pagination !== '...'" :class="pagination === currentPage ? 'active-page' : '' " aria-label="pagination" href="#" @click.prevent="changePage(Number(pagination), false)">
                        <span :class="pagination === currentPage ? '_active' : ''" :data-page="pagination">{{ pagination }}</span>
                    </a>
                    <span v-else>…</span>
                </template>
                <a aria-label="3" href="#" @click.prevent="changePage(currentPage + 3, false)">
                    <span class="_next" data-page="3">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g data-name="Double Arrow"><path d="M12 17a1 1 0 0 1-.707-1.707L14.586 12l-3.293-3.293a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4A1 1 0 0 1 12 17z" style="fill:#1c1b1e"/><path d="M8 17a1 1 0 0 1-.707-1.707L10.586 12 7.293 8.707a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4A1 1 0 0 1 8 17z" style="fill:#1c1b1e"/></g></svg>
                    </span>
                </a>
                <a aria-label="3" href="#" @click.prevent="changePage(currentPage + 1, false)">
                    <span class="_next" data-page="3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <polygon points="7.293 4.707 14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707"/>
                        </svg>
                    </span>
                </a>
            </div>
            <div class="property-list-intro m-40">
                <h1 class="section-title m-25">
                    {{ properties.title }}
                </h1>
                <div class="user-content" v-html="userContent.firstPart">
                </div>
                <div class="user-content hidden" :class="showDesc ? 'active' : ''" v-html="userContent.secondPart">
                </div>
                <div class="center">
                    <a v-if="showBtn" @click.prevent="showText" class="btn-1 type-2 toggle-intro-content" href="#" rel="noreferrer">
                        {{ translations.show_more }}
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>